'use client';

import _objectWithoutProperties from "/codebuild/output/src3402/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["m", "mx", "my", "mt", "mb", "ml", "mr", "me", "ms", "p", "px", "py", "pt", "pb", "pl", "pr", "pe", "ps", "bd", "bg", "c", "opacity", "ff", "fz", "fw", "lts", "ta", "lh", "fs", "tt", "td", "w", "miw", "maw", "h", "mih", "mah", "bgsz", "bgp", "bgr", "bga", "pos", "top", "left", "bottom", "right", "inset", "display", "flex", "hiddenFrom", "visibleFrom", "lightHidden", "darkHidden", "sx"];
import { filterProps } from '../../../utils/filter-props/filter-props.mjs';
import 'react';
import 'react/jsx-runtime';
import '@mantine/hooks';
function extractStyleProps(others) {
  var m = others.m,
    mx = others.mx,
    my = others.my,
    mt = others.mt,
    mb = others.mb,
    ml = others.ml,
    mr = others.mr,
    me = others.me,
    ms = others.ms,
    p = others.p,
    px = others.px,
    py = others.py,
    pt = others.pt,
    pb = others.pb,
    pl = others.pl,
    pr = others.pr,
    pe = others.pe,
    ps = others.ps,
    bd = others.bd,
    bg = others.bg,
    c = others.c,
    opacity = others.opacity,
    ff = others.ff,
    fz = others.fz,
    fw = others.fw,
    lts = others.lts,
    ta = others.ta,
    lh = others.lh,
    fs = others.fs,
    tt = others.tt,
    td = others.td,
    w = others.w,
    miw = others.miw,
    maw = others.maw,
    h = others.h,
    mih = others.mih,
    mah = others.mah,
    bgsz = others.bgsz,
    bgp = others.bgp,
    bgr = others.bgr,
    bga = others.bga,
    pos = others.pos,
    top = others.top,
    left = others.left,
    bottom = others.bottom,
    right = others.right,
    inset = others.inset,
    display = others.display,
    flex = others.flex,
    hiddenFrom = others.hiddenFrom,
    visibleFrom = others.visibleFrom,
    lightHidden = others.lightHidden,
    darkHidden = others.darkHidden,
    sx = others.sx,
    rest = _objectWithoutProperties(others, _excluded);
  var styleProps = filterProps({
    m: m,
    mx: mx,
    my: my,
    mt: mt,
    mb: mb,
    ml: ml,
    mr: mr,
    me: me,
    ms: ms,
    p: p,
    px: px,
    py: py,
    pt: pt,
    pb: pb,
    pl: pl,
    pr: pr,
    pe: pe,
    ps: ps,
    bd: bd,
    bg: bg,
    c: c,
    opacity: opacity,
    ff: ff,
    fz: fz,
    fw: fw,
    lts: lts,
    ta: ta,
    lh: lh,
    fs: fs,
    tt: tt,
    td: td,
    w: w,
    miw: miw,
    maw: maw,
    h: h,
    mih: mih,
    mah: mah,
    bgsz: bgsz,
    bgp: bgp,
    bgr: bgr,
    bga: bga,
    pos: pos,
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    inset: inset,
    display: display,
    flex: flex,
    hiddenFrom: hiddenFrom,
    visibleFrom: visibleFrom,
    lightHidden: lightHidden,
    darkHidden: darkHidden,
    sx: sx
  });
  return {
    styleProps: styleProps,
    rest: rest
  };
}
export { extractStyleProps };